import React from 'react';
import { AppWrapper } from './src/context/app-context'
import './src/styles/global.css'

export const wrapRootElement = ({ element }) => (
  <AppWrapper>{element}</AppWrapper>
)